import React from 'react';

import ConnectGmailButton from './ConnectGmailButton';
import { disconnectGmail, getGmailConnection, GmailConnection } from '../services/gmailService';

export default function Settings() {
  const [loading, setLoading] = React.useState(true);
  const [connection, setConnection] = React.useState<GmailConnection | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  const [disconnecting, setDisconnecting] = React.useState(false);

  const refresh = React.useCallback(async () => {
    try {
      setError(null);
      setLoading(true);
      const c = await getGmailConnection();
      setConnection(c);
    } catch (e: any) {
      const msg = e?.response?.data?.message || e?.message || 'Failed to load Gmail connection';
      setError(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    refresh();
  }, [refresh]);

  const onDisconnect = async () => {
    try {
      setDisconnecting(true);
      await disconnectGmail();
      await refresh();
    } catch (e: any) {
      const msg = e?.response?.data?.message || e?.message || 'Failed to disconnect Gmail';
      setError(msg);
    } finally {
      setDisconnecting(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto py-10 px-6">
      <h2 className="text-2xl font-semibold text-gray-900">Settings</h2>

      <div className="mt-8 rounded border border-gray-200 bg-white p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Gmail</h3>
            <p className="mt-1 text-sm text-gray-600">Connect a Gmail account to enable syncing.</p>
          </div>
          <button
            onClick={refresh}
            className="text-sm px-3 py-1.5 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
            disabled={loading}
          >
            Refresh
          </button>
        </div>

        {loading ? (
          <div className="mt-4 text-sm text-gray-600">Loading…</div>
        ) : connection ? (
          <div className="mt-4 space-y-3">
            <div className="text-sm text-gray-800">
              <div>
                <span className="text-gray-500">Status:</span> {connection.status || 'connected'}
              </div>
              {connection.email && (
                <div>
                  <span className="text-gray-500">Email:</span> {connection.email}
                </div>
              )}
            </div>

            <button
              onClick={onDisconnect}
              disabled={disconnecting}
              className="px-4 py-2 rounded bg-gray-900 text-white disabled:opacity-60"
            >
              {disconnecting ? 'Disconnecting…' : 'Disconnect Gmail'}
            </button>
          </div>
        ) : (
          <div className="mt-4">
            <ConnectGmailButton />
          </div>
        )}

        {error && <div className="mt-4 text-sm text-red-600">{error}</div>}
      </div>
    </div>
  );
}
